
const IMAGES = [
    {
        src: "/res/screenshots/tm01.webp",
        thumbnail: "/res/images/tm01.webp",
        caption: "tm01",
    },
    {
        src: "/res/screenshots/tm02.webp",
        thumbnail: "/res/images/tm02.webp",
        caption: "tm02",
    },
    {
        src: "/res/screenshots/tm03.webp",
        thumbnail: "/res/images/tm03.webp",
        caption: "tm03",
    },
    {
        src: "/res/screenshots/tm05.webp",
        thumbnail: "/res/images/tm05.webp",
        caption: "tm05",
    },
    {
        src: "/res/screenshots/tm06.webp",
        thumbnail: "/res/images/tm06.webp",
        caption: "tm06",
    },
    {
        src: "/res/screenshots/tm07.webp",
        thumbnail: "/res/images/tm07.webp",
        caption: "tm07",
    },
    {
        src: "/res/screenshots/tm08_1.webp",
        thumbnail: "/res/images/tm08_1.webp",
        caption: "tm08_1",
    },
    {
        src: "/res/screenshots/tm08_2.webp",
        thumbnail: "/res/images/tm08_2.webp",
        caption: "tm08_2",
    },
    {
        src: "/res/screenshots/tm08_3.webp",
        thumbnail: "/res/images/tm08_3.webp",
        caption: "tm08_3",
    },
    {
        src: "/res/screenshots/tm10_1.webp",
        thumbnail: "/res/images/tm10_1.webp",
        caption: "tm10_1",
    },
    {
        src: "/res/screenshots/tm10_2.webp",
        thumbnail: "/res/images/tm10_2.webp",
        caption: "tm10_2",
    },
    {
        src: "/res/screenshots/tm10_3.webp",
        thumbnail: "/res/images/tm10_3.webp",
        caption: "tm10_3",
    },
    {
        src: "/res/screenshots/tm10_4.webp",
        thumbnail: "/res/images/tm10_4.webp",
        caption: "tm10_4",
    },
    {
        src: "/res/screenshots/tm11_1.webp",
        thumbnail: "/res/images/tm11_1.webp",
        caption: "tm11_1",
    },
    {
        src: "/res/screenshots/tm11_2.webp",
        thumbnail: "/res/images/tm11_2.webp",
        caption: "tm11_2",
    },
    {
        src: "/res/screenshots/tm12_1.webp",
        thumbnail: "/res/images/tm12_1.webp",
        caption: "tm12_1",
    },
    {
        src: "/res/screenshots/tm12_2.webp",
        thumbnail: "/res/images/tm12_2.webp",
        caption: "tm12_2",
    },
    {
        src: "/res/screenshots/tm13.webp",
        thumbnail: "/res/images/tm13.webp",
        caption: "tm13",
    },
    {
        src: "/res/screenshots/tm14_1.webp",
        thumbnail: "/res/images/tm14_1.webp",
        caption: "tm14_1",
    },
    {
        src: "/res/screenshots/tm14_2.webp",
        thumbnail: "/res/images/tm14_2.webp",
        caption: "tm14_2",
    },
    {
        src: "/res/screenshots/tm14_3.webp",
        thumbnail: "/res/images/tm14_3.webp",
        caption: "tm14_3",
    },
    {
        src: "/res/screenshots/tm15_1.webp",
        thumbnail: "/res/images/tm15_1.webp",
        caption: "tm15_1",
    },
    {
        src: "/res/screenshots/tm15_2.webp",
        thumbnail: "/res/images/tm15_2.webp",
        caption: "tm15_2",
    },
    {
        src: "/res/screenshots/tm15_3.webp",
        thumbnail: "/res/images/tm15_3.webp",
        caption: "tm15_3",
    },
    {
        src: "/res/screenshots/tm16_1.webp",
        thumbnail: "/res/images/tm16_1.webp",
        caption: "tm16_1",
    },
    {
        src: "/res/screenshots/tm16_2.webp",
        thumbnail: "/res/images/tm16_2.webp",
        caption: "tm16_2",
    },
    {
        src: "/res/screenshots/tm17_1.webp",
        thumbnail: "/res/images/tm17_1.webp",
        caption: "tm17_1",
    },
    {
        src: "/res/screenshots/tm17_2.webp",
        thumbnail: "/res/images/tm17_2.webp",
        caption: "tm17_2",
    },
    {
        src: "/res/screenshots/tm17_3.webp",
        thumbnail: "/res/images/tm17_3.webp",
        caption: "tm17_3",
    },
    {
        src: "/res/screenshots/tm18_1.webp",
        thumbnail: "/res/images/tm18_1.webp",
        caption: "tm18_1",
    },
    {
        src: "/res/screenshots/tm18_2.webp",
        thumbnail: "/res/images/tm18_2.webp",
        caption: "tm18_2",
    },
    {
        src: "/res/screenshots/tm18_3.webp",
        thumbnail: "/res/images/tm18_3.webp",
        caption: "tm18_3",
    },
    {
        src: "/res/screenshots/tm18_4.webp",
        thumbnail: "/res/images/tm18_4.webp",
        caption: "tm18_4",
    },
    {
        src: "/res/screenshots/tm19_1.webp",
        thumbnail: "/res/images/tm19_1.webp",
        caption: "tm19_1",
    },
    {
        src: "/res/screenshots/tm19_2.webp",
        thumbnail: "/res/images/tm19_2.webp",
        caption: "tm19_2",
    },
    {
        src: "/res/screenshots/tm19_3.webp",
        thumbnail: "/res/images/tm19_3.webp",
        caption: "tm19_3",
    },
    {
        src: "/res/screenshots/tm19_4.webp",
        thumbnail: "/res/images/tm19_4.webp",
        caption: "tm19_4",
    },
    {
        src: "/res/screenshots/tm19_5.webp",
        thumbnail: "/res/images/tm19_5.webp",
        caption: "tm19_5",
    },
    {
        src: "/res/screenshots/tm19_6.webp",
        thumbnail: "/res/images/tm19_6.webp",
        caption: "tm19_6",
    },
    {
        src: "/res/screenshots/tm20_1.webp",
        thumbnail: "/res/images/tm20_1.webp",
        caption: "tm20_1",
    },
    {
        src: "/res/screenshots/tm20_2.webp",
        thumbnail: "/res/images/tm20_2.webp",
        caption: "tm20_2",
    },
    {
        src: "/res/screenshots/tm20_3.webp",
        thumbnail: "/res/images/tm20_3.webp",
        caption: "tm20_3",
    },
    {
        src: "/res/screenshots/tm20_4.webp",
        thumbnail: "/res/images/tm20_4.webp",
        caption: "tm20_4",
    },
    {
        src: "/res/screenshots/tm20_5.webp",
        thumbnail: "/res/images/tm20_5.webp",
        caption: "tm20_5",
    },
]

export default IMAGES;
